export default __webpack_public_path__ + "static/gilroy-regular-38ff4121de55e75a589ad2f3c2d8cbb8.eot";